import { render, staticRenderFns } from "./AddressSidebar.vue?vue&type=template&id=66400854&scoped=true&"
import script from "./AddressSidebar.vue?vue&type=script&lang=js&"
export * from "./AddressSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66400854",
  null
  
)

export default component.exports